import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { COLORS } from '../styles/theme'
import Axios from 'axios'
import config from '../config'
import ModalVideo from 'react-modal-video'
import LoadIcon from './LoadIcon'
import Amplitude from '../utils/amplitudeHelper'
import ProgrammeSession from './ProgrammeSession'

const AgendaWrapper = styled.div`
  padding: 32px 0;
  header {
    .toggle-button {
      background: linear-gradient(#FF9821, #F83636);
      outline: none;
      border-radius: 32px;
      color: white;
      padding: 2px 10px;
      border: 1px solid white;
      margin:0 4px;
      font-size: 16px;
      &:hover:not(.active) {
        color: ${COLORS.primary};
        background: #ffad2c;
      }
    }
    .active {
      color: #fff;
      border: 1px solid #fff;
      font-style: italic;
      font-weight: bold;
    }
  }
  section.agenda-container {
    padding: 32px 0;
  }
  .programme-header {
    background: #ffe8b7;
    display: flex;
    text-align: center;
    font-weight: 700;
    font-size: 15px;
    padding: 8px;
    color: #a11748;
    margin-bottom: 8px;
  }
`

export default function ProgrammeListing({ replayButton, hallNumber, inHall, handlePlayback }) {
  const [programmeList, setProgrammeList] = useState([])
  const [tabId, setTabId] = useState(null)
  const [dateTab, setDateTab] = useState([])
  const [isLoading, setIsLoading] = useState(true);


  // useEffect(() => {
  //   Axios({
  //     url: `${config.apiUrl}/api/programme_tabs/${hallNumber}`,
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
  //     },
  //   }).then((result) => {
  //     setIsLoading(false)
  //     setDateTab(result.data.tabs)
  //     setTabId(result.data.tabs[0].id)
  //   })
  // }, [hallNumber])

  // useEffect(() => {
  //   Axios({
  //     url: `${config.apiUrl}/api/programme_sessions/${tabId}`,
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
  //     },
  //   }).then((result) => {
  //     setIsLoading(false)
  //     setProgrammeList(result.data.sessions)
  //   })
  // }, [tabId])


  return (
    <AgendaWrapper>
      <header>
        {dateTab.map((item, index) => (
          <button key={`datetab-${index}`} className={`toggle-button ${ item.id === tabId ? 'active' : ''}`} onClick={() => setTabId(item.id)} >
            Day {index+1}
          </button>
        ))}
      </header>
      <section className="agenda-container">
        {isLoading && <LoadIcon />}
        {
          inHall !== true &&
          <div className="programme-header">
            <div className="w-25">TIMING (MYT)</div>
            <div className="w-75">TOPIC</div>
          </div>
        }
        <div>
          {programmeList
            .map((programme) => (
              <ProgrammeSession key={programme.id} handlePlayback={handlePlayback} programme={programme} replayButton={replayButton} inHall={inHall}  />
            ))}
        </div>
      </section>
  </AgendaWrapper>
  )
}
